import React, { useState, Fragment } from "react";
import { useDispatch } from "react-redux";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Grid2 from "@mui/material/Grid2";
import FormInput from "../Common/FormInputs/MuiTextField";
import AppButton from "../Common/Button/Button";
import {
  LabelText,
  InfoPairLabel,
  InfoPairValue,
  SectionSubHeading,
} from "../Common/Typography/AppTypography";
import Alert from "../layout/Alert";
import Dialog from "../Common/Dailog/Dailog";
import { setAlert } from "../../action/alert";
import { deleteAsset, getAssetErrorMessage } from "../../action/asset";
import customConfig from "../../config";
import { useDesignTokens } from "../../theme/useDesignTokens";
import { formControlSx } from "./assetConstants";

function AssetDeleteForm() {
  const dispatch = useDispatch();
  const { colors } = useDesignTokens();
  const [assetId, setAssetId] = useState("");
  const [loading, setLoading] = useState(false);
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);

  const resetForm = () => {
    setAssetId("");
    setLoading(false);
    setShowDeleteDialog(false);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!assetId?.trim()) {
      dispatch(setAlert("Asset ID Cannot be Empty", "danger"));
      return;
    }

    setShowDeleteDialog(true);
  };

  const handleCloseDeleteDialog = () => {
    if (!loading) {
      setShowDeleteDialog(false);
    }
  };

  const handleDeleteConfirm = async () => {
    setLoading(true);

    try {
      await deleteAsset(assetId.trim());
      dispatch(setAlert(customConfig.DELETE_SUCCESS, "success"));
      resetForm();
    } catch (err) {
      dispatch(setAlert(getAssetErrorMessage(err, "Request failed", "Asset not found"), "danger"));
      setShowDeleteDialog(false);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Fragment>
      <Paper sx={{ p: 2, boxShadow: 2, borderRadius: 1 }}>
        <Alert />
        <form onSubmit={handleSubmit}>
          <Grid2
            container
            spacing={2}
            columnSpacing={{ xs: 2, md: 2 }}
            sx={{ mb: 3, alignItems: "center", width: "100%" }}
          >
            <Grid2 size={{ xs: 12, md: "auto" }} sx={{ flexShrink: 0 }}>
              <LabelText sx={{ fontWeight: 600, whiteSpace: "nowrap" }}>
                Asset ID:
              </LabelText>
            </Grid2>
            <Grid2
              size={{ xs: 12, md: "auto" }}
              sx={{
                minWidth: 0,
                width: { xs: "100%", md: formControlSx.maxWidth.md },
                maxWidth: formControlSx.maxWidth,
              }}
            >
              <FormInput
                type="text"
                size="small"
                fullWidth
                label="Enter Asset ID"
                placeholder="e.g. home-banner-test"
                value={assetId}
                onChange={(e) => setAssetId(e.target.value)}
                sx={{ width: "100%", maxWidth: "100%" }}
              />
            </Grid2>
          </Grid2>

          <Box sx={{ display: "flex", gap: 1.5, alignItems: "center", flexWrap: "wrap" }}>
            <AppButton
              variant="primary"
              size="medium"
              type="submit"
              disabled={loading}
              loading={loading}
            >
              Delete Asset
            </AppButton>
            <AppButton
              variant="ghost"
              size="medium"
              type="button"
              onClick={resetForm}
              disabled={loading}
            >
              Reset
            </AppButton>
          </Box>
        </form>
      </Paper>

      <Dialog
        open={showDeleteDialog}
        onClose={handleCloseDeleteDialog}
        title="Delete Asset"
        actions={[
          {
            label: "Cancel",
            variant: "ghost",
            onClick: handleCloseDeleteDialog,
            disabled: loading,
          },
          {
            label: "Delete",
            tooltip: "Click to delete the asset.",
            variant: "danger",
            onClick: handleDeleteConfirm,
            loading,
            slotProps: {
              popper: {
                sx: { zIndex: 2400 },
              },
            },
          },
        ]}
        sx={{
          zIndex: 2300,
        }}
      >
        <Box
          sx={{
            bgcolor: colors?.disabled?.bg,
            p: 3,
            borderRadius: 2,
            textAlign: "left",
          }}
        >
          <SectionSubHeading sx={{ mb: 2 }}>
            Are you sure you want to delete this asset?
          </SectionSubHeading>

          <Box>
            <InfoPairLabel>Asset ID:</InfoPairLabel>
            <InfoPairValue sx={{ wordBreak: "break-all" }}>
              {assetId.trim()}
            </InfoPairValue>
          </Box>
        </Box>
      </Dialog>
    </Fragment>
  );
}

export default AssetDeleteForm;
